import React from 'react'

import * as S from './styles'

export type LoadingProps = {
  width?: string
  height?: string
}

const Loading = ({ width, height }: LoadingProps) => (
  <S.Loading width={width} height={height} />
)

export default Loading
